import { render, staticRenderFns } from "./ClosedList.vue?vue&type=template&id=ffceeb7c&scoped=true"
import script from "./ClosedList.vue?vue&type=script&lang=js"
export * from "./ClosedList.vue?vue&type=script&lang=js"
import style0 from "./ClosedList.vue?vue&type=style&index=0&id=ffceeb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffceeb7c",
  null
  
)

export default component.exports